import { clamp } from './utils.js'

export const pageMethods = {
  async renderThumbnails() {
    this.pageList.innerHTML = ''
    for (let index = 0; index < this.pages.length; index += 1) {
      const pageState = this.pages[index]
      if (pageState.deleted) continue
      const visibleIndex = this.visiblePages.indexOf(pageState)
      const item = document.createElement('button')
      item.className = 'page-thumb'
      item.type = 'button'
      item.draggable = true
      item.dataset.pageId = pageState.id
      item.innerHTML = `<canvas></canvas><span>${visibleIndex + 1}</span>`
      item.addEventListener('click', () => {
        this.currentIndex = visibleIndex
        this.renderCurrentPage()
      })
      item.addEventListener('dragstart', event => {
        event.dataTransfer.setData('text/plain', String(this.pages.indexOf(pageState)))
      })
      item.addEventListener('dragover', event => event.preventDefault())
      item.addEventListener('drop', event => this.reorderPage(event, pageState))
      this.pageList.append(item)

      const pdfPage = await this.pdfForPage(pageState).getPage(pageState.sourceIndex + 1)
      const viewport = pdfPage.getViewport({ scale: 0.18, rotation: pdfPage.rotate + pageState.rotation })
      const canvas = item.querySelector('canvas')
      canvas.width = Math.floor(viewport.width)
      canvas.height = Math.floor(viewport.height)
      await pdfPage.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
    }
    this.highlightThumb()
  },

  reorderPage(event, targetState) {
    event.preventDefault()
    const fromIndex = Number(event.dataTransfer.getData('text/plain'))
    const toIndex = this.pages.indexOf(targetState)
    if (!Number.isInteger(fromIndex) || fromIndex === toIndex) return
    this.recordHistory()
    const [moved] = this.pages.splice(fromIndex, 1)
    this.pages.splice(toIndex, 0, moved)
    this.currentIndex = this.visiblePages.indexOf(moved)
    this.renderThumbnails()
    this.renderCurrentPage()
    this.updateDirtyState()
    this.setStatus('Page order updated.')
  },

  rotateCurrent(delta) {
    const pageState = this.visiblePages[this.currentIndex]
    if (!pageState) return
    this.recordHistory()
    Object.keys(pageState.textEdits).forEach(id => {
      pageState.textEdits[id] = this.rotateTextEditRect(pageState.textEdits[id], delta)
    })
    if (this.selectedTextItem) this.selectedTextItem = this.rotateTextEditRect(this.selectedTextItem, delta)
    pageState.rotation = (pageState.rotation + delta + 360) % 360
    this.renderThumbnails()
    this.renderCurrentPage()
    this.updateDirtyState()
    this.setStatus('Page rotated.')
  },

  deleteCurrent() {
    const pageState = this.visiblePages[this.currentIndex]
    if (!pageState) return
    this.recordHistory()
    pageState.deleted = true
    this.currentIndex = clamp(this.currentIndex, 0, this.visiblePages.length - 1)
    this.renderThumbnails()
    if (this.visiblePages.length) {
      this.renderCurrentPage()
      this.updateDirtyState()
      this.setStatus('Page removed from export.')
    } else {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.annotationLayer.innerHTML = ''
      this.markupLayer.innerHTML = ''
      this.enablePageActions(false)
      this.updateDirtyState()
      this.setStatus('All pages removed.')
    }
  },

  updateCounters() {
    const currentPage = document.querySelector('.current-page')
    const totalPages = document.querySelector('.total-pages')
    if (currentPage) currentPage.textContent = this.visiblePages.length ? String(this.currentIndex + 1) : '0'
    if (totalPages) totalPages.textContent = String(this.visiblePages.length)
    document.querySelector('.zoom-label').textContent = `${Math.round(this.zoom * 100)}%`
  },

  highlightThumb() {
    const current = this.visiblePages[this.currentIndex]
    document.querySelectorAll<HTMLButtonElement>('.page-thumb').forEach(button => {
      button.classList.toggle('active', button.dataset.pageId === current?.id)
    })
  },

  enablePageActions(enabled) {
    document.querySelectorAll('.page-action, .viewer-toolbar .tool-btn, .viewer-toolbar .mode-btn').forEach(button => {
      this.setToolbarDisabled(button, !enabled)
    })
  }
}
